module.exports = __webpack_public_path__ + "static/img/page49.c354774.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page49.jpg
// module id = Rz5I
// module chunks = 0